export default {
    data() {
        return {}
    },
    computed: {
        SelectedConfigDetails: {
            cache: false,
            get() {
                return this.$store.getters['configurations/getDetails']()
            }
        },
        maybeTitle() {
            return (
                this.SelectedConfigDetails?.title?.[this.$i18n.locale] ||
                this.page?.title?.[this.$i18n.locale] ||
                ''
            )
        },
        maybeSubtitle() {
            return (
                this.SelectedConfigDetails?.subtitle?.[this.$i18n.locale] ||
                this.page?.subtitle?.[this.$i18n.locale] ||
                ''
            )
        },
        maybeThumbnail() {
            return (
                this.SelectedConfigDetails?.thumbnail ||
                this.page?.headerThumbnail ||
                {}
            )
        },
        maybeGallery() {
            return (
                this.SelectedConfigDetails?.gallery ||
                this.product?.gallery ||
                {}
            )
        },
        maybeResources() {
            return (
                this.SelectedConfigDetails?.resources ||
                this.product?.resourceTag ||
                {}
            )
        },
        maybeIntro() {
            return (
                this.SelectedConfigDetails?.intro?.[this.$i18n.locale] ||
                this.product?.intro?.[this.$i18n.locale] ||
                null
            )
        },
        maybeIntroExtra() {
            return (
                this.SelectedConfigDetails?.introExtra?.[this.$i18n.locale] ||
                null
            )
        },
        maybeCustomTextInputs() {
            return this.SelectedConfigDetails?.customTextInputs || null
        }
    }
}
